<span *ngIf="error">Unbekannt</span>
<span *ngIf="!error">
  <a *ngIf="!show" routerLink="/profile/{{user['customIdName']}}" matTooltip="Profil öffnen" matTooltipPosition="above">
    {{ user['firstName'] }} {{ user['lastName'] }}
  </a>
  <span *ngIf="show=='description'">{{user['position']}} bei {{ user['company'] }}</span>
<a *ngIf="show=='phone'" href="tel:{{ user['phone'] }}">{{user['phone']}}</a>
<span *ngIf="show=='fax'">{{user['fax']}}</span>

</span>